import React, { useState } from "react";
import PageHeading from "../../components/PageHeading";
import { useQuery, useQueryClient } from "react-query";

import { Navigate, useNavigate, useParams } from "react-router-dom";
import DCard from "../../components/DCard";
import DSpinner from "../../components/DSpinner";
import Table from "../../components/Table";
import DButton from "../../components/DButton";
import { useDisclosure } from "@chakra-ui/react";
import DModal from "../../components/DModal";
import { toast } from "react-hot-toast";
import customPriceServices from "../../services/customPrice";

import { BiPlusCircle } from "react-icons/bi";


const columns = [
  { Header: "الرقم التعريقي للمنتج", accessor: "subitem_id" },
  { Header: "السعر المخصص", accessor: "price" },
  { Header: "اسم المستخدم", accessor: "user_name" },
  { Header: "العمليات", accessor: "actions" },
];
const Index = ({ title }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [currentPage, setCurrentPage] = useState(0);
  const [deleteCustomPriceId, setDeleteCustomPriceId] = useState();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { id } = useParams();
  const { data, isLoading, error } = useQuery(
    ["getAllCustomPricesBySubitem", currentPage],
    () => customPriceServices.getAllCustomPricesBySubitem(id, currentPage + 1)
  );
  const editCustomPrice = (id) => {
    navigate("/custom-prices/edit/" + id);
  };
  const deleteCustomPrice = () => {
    onClose();
    customPriceServices
      .deleteCustomPrice(deleteCustomPriceId)
      .then((res) => {
        toast.success("تم الحذف بنجاح");
        queryClient.refetchQueries(["getAllCustomPricesBySubitem"]);
      })
      .catch((err) => {
        if (err.response.status === 404) {
          toast.error("الرسالة غير موجودة");
        } else {
          toast.error("حصل خطأ ما");
        }
      });
  };
  const getFormattedData = (data) => {
    if (data.length > 0) {
      return data.map((d) => ({
        ...d,
        actions: (
          <div className="flex items-center justify-center gap-2">
            <DButton
              bgColor="primary"
              className=" px-4 text-white  rounded-[50px_!important]"
              onClick={() => {
                editCustomPrice(d.id)
              }}
            >
              تعديل
            </DButton>

            <DButton
              bgColor="danger"
              className={"text-white px-4 rounded-[50px_!important]"}
              onClick={() => {
                onOpen();
                setDeleteCustomPriceId(d.id);
              }}
            >
              حذف
            </DButton>
          </div>
        ),
      }));
    }
    return [];
  };
  if (error) {
    return <Navigate to="/404" />;
  }
  return (
    <div>
      <button
        onClick={() => {
          navigate(`/subitems/${id}/custom-prices/add`);
        }}
        className="fixed z-[999999999999999999999999] rounded-full   justify-center text-center content-center bottom-16 rtl:left-16 ltr:right-16 "
      >
        <div className=" bg-blue-800 rounded-full p-4">
          <BiPlusCircle size={36} color="white" />
        </div>
      </button>
      <DModal
        isOpen={isOpen}
        onClose={onClose}
        modelType="delete"
        clickHandler={deleteCustomPrice}
        bodyText="هل تريد بالفعل حذف هذا السعر المخصص ؟"
      />
      <PageHeading>{title}</PageHeading>
      <DCard className={`relative ${isLoading ? "min-h-[400px]" : ""}`}>
        {isLoading ? (
          <DSpinner />
        ) : (
          <Table
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalData={data.data.total}
            head={columns}
            body={getFormattedData(data.data.data)}
          />
        )}
      </DCard>
    </div>
  );
};

export default Index;
